'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFlipToBack = function MdFlipToBack(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 28.4v-3.4h3.4v3.4h-3.4z m0-20v-3.4h3.4v3.4h-3.4z m-16.6 3.2v20h20v3.4h-20q-1.4 0-2.4-1t-1-2.4v-20h3.4z m23.2 16.8v-3.4h3.4q0 1.3-1 2.3t-2.4 1.1z m0-13.4v-3.4h3.4v3.4h-3.4z m0 6.6v-3.2h3.4v3.2h-3.4z m-16.6 6.8q-1.4 0-2.4-1.1t-1-2.3h3.4v3.4z m6.6-23.4v3.4h-3.2v-3.4h3.2z m10 0q1.4 0 2.4 1t1 2.4h-3.4v-3.4z m-10 20v3.4h-3.2v-3.4h3.2z m-6.6-20v3.4h-3.4q0-1.4 1-2.4t2.4-1z m0 13.4v3.2h-3.4v-3.2h3.4z m0-6.8v3.4h-3.4v-3.4h3.4z' })
        )
    );
};

exports.default = MdFlipToBack;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/flip-to-back.js
// module id = 2894
// module chunks = 0